// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"AddMenuSupplier_pageHolder__3Yo3T","imageHolder":"AddMenuSupplier_imageHolder__3TkzV","PageHolder":"AddMenuSupplier_PageHolder__3uebb"};